/**
 * adminGroupResourceAwsCacheRelationship模块接口列表
 */
import $http from '../utils/http'; // 导入http中创建的axios实例

const adminGroupResourceAwsCacheRelationship = {
  //添加
  create(params) {
    return $http.post(`${global.API_URL}/sme/adminGroupResourceAwsCacheRelationship/create`,params);
  },
  //分页
  pagingQuery(params) {
    return $http.post(`${global.API_URL}/sme/adminGroupResourceAwsCacheRelationship/pagingQuery`,params);
  },
  //删除
  delete(params) {
    return $http.post(`${global.API_URL}/sme/adminGroupResourceAwsCacheRelationship/delete`,params);
  }
}

export default adminGroupResourceAwsCacheRelationship;



// WEBPACK FOOTER //
// ./src/api/adminGroupResourceAwsCacheRelationship.js